// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardFormUtils = require("./PropertyWizardFormUtils.bs.js");
let WizardDisplayNeighborhoodField = require("../wizard/WizardDisplayNeighborhoodField.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.bs.js");
let PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.bs.js");

let convertFragment = PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localGeocodingStatus_decode = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Utils.localGeocodingStatus_decode;

let FormStateFragment_localGeocodingStatus_fromString = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Utils.localGeocodingStatus_fromString;

let FormStateFragment = {
  localGeocodingStatus_decode: FormStateFragment_localGeocodingStatus_decode,
  localGeocodingStatus_fromString: FormStateFragment_localGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Description__DisplayNeighborhood(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, props.formState);
  let displayNeighborhoodIsValid = PropertyWizardFormRelay__Validators__Description.DisplayNeighborhood.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let displayNeighborhood = PropertyWizardFormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.displayNeighborhood = value !== undefined ? ({
          id: value.id,
          label: value.label
        }) : undefined;
      return newrecord;
    }
  }, props.stepHasBeenTouched, draft.draftProperty.displayNeighborhood, displayNeighborhoodIsValid);
  let helpText;
  let tmp = match.mode;
  helpText = typeof tmp !== "object" || tmp.TAG !== "Rebroadcast" ? "Select what neighborhood you would like to display on your broadcast.\nCan't find your preferred neighborhood? Just leave it blank. This won't have an impact on matching." : "You can edit the display neighborhood if you wish. This is for display only and has no impact on matching.";
  return JsxRuntime.jsx(WizardDisplayNeighborhoodField.make, {
    displayNeighborhood: displayNeighborhood,
    displayNeighborhoods: formState.displayNeighborhoods,
    geocodingStatus: formState.geocodingStatus,
    helpText: helpText
  });
}

let Validators;

let FormControl;

let make = PropertyWizardRelay__Description__DisplayNeighborhood;

exports.Validators = Validators;
exports.FormControl = FormControl;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
